import { errorToObject } from '@onyx/utils/error';
import omit from 'lodash/omit';

import type {
  SendErrorEvent,
  SendEvent,
  SendPageLoadFinishedEvent,
} from '../../interface/event';
import { pageProperties, sessionProperties } from './properties';
import { toDynatraceJSONObject } from './utils';

export const sendEvent: SendEvent = (
  eventName: string,
  eventProperties?: Record<string, unknown>
) => {
  if (typeof window === 'undefined') {
    return;
  }

  const payload = {
    ...toDynatraceJSONObject(Object.fromEntries(pageProperties)),
    ...toDynatraceJSONObject(Object.fromEntries(sessionProperties)),
    ...toDynatraceJSONObject(eventProperties ?? {}),
  };

  window.dynatrace?.sendBizEvent(
    eventName,
    // `timestamp` must be omitted, otherwise Dynatrace drops the bizevent.
    // https://docs.dynatrace.com/docs/observe/business-analytics/ba-events-enrichment#oneagent-and-external-business-event-enrichment
    omit(payload, ['timestamp'])
  );
};

export const sendErrorEvent: SendErrorEvent = (
  error: Error,
  eventName = 'custom_error',
  eventProperties?: Record<string, unknown>
) => {
  sendEvent(eventName, {
    ...eventProperties,
    isError: true,
    error: errorToObject(error),
  });
};

export const sendPageLoadFinishedEvent: SendPageLoadFinishedEvent = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dtrum?.signalLoadEnd();
};
